import { HTI_SSO_ENABLED } from '../../../config/constants';
import type { RouterConfig, SelfHelpCloseOnesRouteName } from '../types';

// Pages.
import PageAccountCloseOnes from '../../../pages/AccountCloseOnes';
import PageDiaryAdd from '../../../pages/Diary/Add';
import PageDiaryOverview from '../../../pages/Diary/Overview';
import PageForum from '../../../pages/Forum';
import PageForumCreatePost from '../../../pages/Forum/CreatePost';
import PageLogin from '../../../pages/Login';
import PageLogout from '../../../pages/Logout';
import PageOnboarding from '../../../pages/Onboarding';
import PageOnboardingHti from '../../../pages/OnboardingHti';
import PageResetPassword from '../../../pages/ResetPassword';
import PageValidateEmail from '../../../pages/ValidateEmail';

const routesConfigSelfHelpCloseOnes: RouterConfig<SelfHelpCloseOnesRouteName> = {
  accountBase: {
    basePath: '/account',
    nl: '/nl/account',
    en: '/en/account',
    type: 'private',
    exact: false,
    component: PageAccountCloseOnes,
  },
  diaryAdd: {
    basePath: '/dagboek/nieuwe-ervaring',
    nl: '/nl/dagboek/nieuwe-ervaring',
    en: '/en/diary/new-entry',
    type: 'private',
    component: PageDiaryAdd,
  },
  diaryOverview: {
    basePath: '/dagboek',
    nl: '/nl/dagboek',
    en: '/en/diary',
    type: 'private',
    component: PageDiaryOverview,
  },
  forumCreatePost: {
    basePath: '/forum/create/:category',
    nl: '/nl/forum/create/:category',
    en: '/en/forum/create/:category',
    type: 'private',
    component: PageForumCreatePost,
  },
  forumOverview: {
    basePath: '/forum',
    nl: '/nl/forum',
    en: '/en/forum',
    type: 'private',
    component: PageForum,
  },
  login: {
    basePath: '/inloggen',
    nl: '/nl/inloggen',
    en: '/en/login',
    type: 'public',
    component: PageLogin,
  },
  logout: {
    basePath: '/user/logout',
    nl: '/nl/user/logout',
    en: '/en/user/logout',
    type: 'private',
    component: PageLogout,
  },
  onboardingCredentials: {
    basePath: '/registreren/gegevens',
    nl: '/nl/registreren/gegevens',
    en: '/en/register/credentials',
    type: 'public',
    component: PageOnboarding,
  },
  onboardingCredentialsHti: {
    basePath: '/registreren-hti/gegevens',
    nl: '/nl/registreren-hti/gegevens',
    en: '/en/register-hti/credentials',
    type: 'private',
    component: PageOnboardingHti,
    condition: () => HTI_SSO_ENABLED,
  },
  resetPassword: {
    basePath: '/user/reset/:uid/:timestamp/:hash',
    nl: '/nl/user/reset/:uid/:timestamp/:hash',
    en: '/en/user/reset/:uid/:timestamp/:hash',
    type: 'default',
    component: PageResetPassword,
  },
  resetPasswordLogin: {
    basePath: '/user/reset/:uid/:timestamp/:hash/login',
    nl: '/nl/user/reset/:uid/:timestamp/:hash/login',
    en: '/en/user/reset/:uid/:timestamp/:hash/login',
    type: 'default',
    component: PageResetPassword,
  },
  resetPasswordRequest: {
    basePath: '/wachtwoord-vergeten',
    nl: '/nl/wachtwoord-vergeten',
    en: '/en/forgot-password',
    type: 'default',
    component: PageResetPassword,
  },
  validateEmail: {
    basePath: '/validate/:uid/:timestamp/:hash',
    nl: '/nl/validate/:uid/:timestamp/:hash',
    en: '/en/validate/:uid/:timestamp/:hash',
    type: 'default',
    component: PageValidateEmail,
  },
};

export default routesConfigSelfHelpCloseOnes;
